export default "__VITE_ASSET__COb9xv7f__"